let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ld9Uk")).then(() => parcelRequire('VgyAW'));